// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SoundFilledSvg from "@ant-design/icons-svg/es/asn/SoundFilled";
import AntdIcon from '../components/AntdIcon';

var SoundFilled = function SoundFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: SoundFilledSvg
  }));
};

SoundFilled.displayName = 'SoundFilled';
export default React.forwardRef(SoundFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/SoundFilled.js
// module id = 1855
// module chunks = 0